import { Directive, ElementRef, OnInit, inject } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { getComponentStyles } from '@flowx/core-theme'

import { ComponentType } from '../injectors'

@Directive({
  selector: '[flxComponentThemeBase]',
  standalone: true,
  host: {
    '[class]': 'themeClassName',
    '[style.visibility]': 'visibility',
  },
})
export class FlxComponentThemeBaseDirective implements OnInit {
  #element = inject(ElementRef).nativeElement
  #componentType = inject(ComponentType, { self: true, optional: true })
  themeClassName = null
  visibility: string | null // used to delay render until all styles are applied

  ngOnInit(): void {
    // The display setting here overrides the layout display settings. We should figure out if it's still a problem, and if so, find another solution

    const initialVisibility = this.#element.style.visibility
    this.visibility = 'hidden'
    const styleClasses = (
      Array.isArray(this.#componentType) ? this.#componentType : [this.#componentType]
    ).map((componentType) => getComponentStyles(componentType, theme()))
    this.themeClassName = `${styleClasses.join(' ')} flx-themed`
    this.visibility = initialVisibility
  }
}
